// extracted by mini-css-extract-plugin
export default {"mainSettings":"MainSettings_mainSettings__fysDU","options":"MainSettings_options__3pzbK"};